
export const MEI = { name: 'LHP | Narumiya Mei',
    role: 'Pitcher | Tokyo',
    details: 'Throws Left',
    edu: 'Inashiro Industrial High School ',
    affiliation: 'NPB - Yomiuri Giants',
    photo:'/Mei.png'
}

export const SANADA = { name: 'RHP | Sanada Shunpei',
    role: 'Pitcher | 3rd year | Tokyo',
    details: 'Throws Right',
    edu: 'Sport and Wellness, Rikkyo University | Yakushi High School ',
    affiliation: 'Tokyo Six University Baseball Federation',
    photo:'/Sanada.png'
}

export const CARLOS = { name: 'CF | Kamiya Carlos Toshiki',
    role: 'CF | 3rd year | Tokyo',
    details: 'Throws Right, Bats Right',
    edu: 'Sport and Wellness, Rikkyo University | Inashiro Industrial ',
    affiliation: 'Tokyo Six University Baseball Federation',
    photo:'/Carlos.png'
}

